import script from "./es-dashboard-component.vue?vue&type=script&setup=true&lang=js"
export * from "./es-dashboard-component.vue?vue&type=script&setup=true&lang=js"

import "./es-dashboard-component.vue?vue&type=style&index=0&id=3c9b2895&lang=scss"

const __exports__ = script;

export default __exports__